// extracted by mini-css-extract-plugin
export default {"nav":"Header_nav__J8WFt","header":"Header_header__HXQOm"};